var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-row',{attrs:{"title":"Property PIN number"}},[_c('input-text',{staticClass:"w-1/3 lg:w-1/4",attrs:{"value":_vm.property.property_pin,"name":"property_pin","placeholder":"Code","read_only":_vm.read_only}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }